import React from 'react';
import { Loader2 } from 'lucide-react';
import type { ProcessingProgress } from '../types';

interface ProcessingViewProps {
  progress: ProcessingProgress;
}

const ProcessingView: React.FC<ProcessingViewProps> = ({ progress }) => {
  const pct = Math.round((progress.current / progress.total) * 100);

  return (
    <div className="flex-1 flex items-center justify-center p-8">
      <div className="max-w-md w-full text-center animate-fade-in">
        <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center">
          <Loader2 size={40} className="text-cyan-400 animate-spin" />
        </div>

        <h2 className="text-xl font-bold text-slate-100 mb-2">Processing images...</h2>
        <p className="text-sm text-slate-400 mb-8">
          {progress.current} of {progress.total} &middot; {progress.currentFileName}
        </p>

        <div className="w-full bg-slate-800 rounded-full h-2.5 mb-2 overflow-hidden">
          <div
            className="h-full bg-gradient-to-r from-cyan-600 to-cyan-400 rounded-full transition-all duration-300 ease-out"
            style={{ width: `${pct}%` }}
          />
        </div>
        <p className="text-xs text-slate-500">{pct}% complete</p>
      </div>
    </div>
  );
};

export default ProcessingView;
